import React from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { LkpLoading } from 'components';
import { CalendarContainer, CalendarContentWrapper, CalendarToolBar, CalendarLoadingOverlay } from './styled';
import { CalendarToolbar } from './components/CalendarToolbar';
import { CalendarFilters } from './components/CalendarFilters';
import { WeekView } from './components/WeekView';
import { useCalendarEvents } from '../../hooks/useCalendarEvents';
import { CalendarView, ViewOption } from '../../hooks/useCalendarNavigation';
import { EventsByDate } from '../../utils/eventUtils';

interface CalendarProps {
  setExecutoresSetoresModalOpen: (open: boolean) => void;
  setAmbientesEquipamentosModalOpen: (open: boolean) => void;
  setPlanosModalOpen: (open: boolean) => void;
  currentDate: Date;
  view: CalendarView;
  viewsOptions: ViewOption[];
  handleViewChange: (value: string | number | null) => void;
  goToToday: () => void;
  navigate: (direction: 'prev' | 'next') => void;
  weekDays: Date[];
  type: 'pendentes' | 'baixadas';
  setType: (type: 'pendentes' | 'baixadas') => void;
  planosSelectionLabel: string;
  openFilters: boolean;
  setOpenFilters: (open: boolean) => void;
  hasActiveFilters: boolean;
  clearAllFilters: () => void;
  events: EventsByDate;
  isLoadingEvents: boolean;
  fetchAgendaTasks: (isWeekView?: boolean) => Promise<void>;
}

export const Calendar: React.FC<CalendarProps> = ({
  setExecutoresSetoresModalOpen,
  setAmbientesEquipamentosModalOpen,
  setPlanosModalOpen,
  currentDate,
  view,
  viewsOptions,
  handleViewChange,
  goToToday,
  navigate,
  weekDays,
  type,
  setType,
  planosSelectionLabel,
  openFilters,
  setOpenFilters,
  hasActiveFilters,
  clearAllFilters,
  events,
  isLoadingEvents,
  fetchAgendaTasks,
}) => {
  const {
    events: calendarEvents,
    horasPrevistasByDate,
    handleDragEndEvent,
  } = useCalendarEvents({
    initialEvents: events,
    fetchAgendaTasks,
    isWeekView: view === CalendarView.Semana,
  });

  const filtersButtonLabel = openFilters ? 'Ocultar Filtros' : 'Exibir Filtros';
  const showClearFilters = openFilters && hasActiveFilters;

  return (
    <CalendarContainer>
      <CalendarToolBar>
        <CalendarToolbar
          currentDate={currentDate}
          view={view}
          viewsOptions={viewsOptions}
          onViewChange={handleViewChange}
          onNavigate={navigate}
          onGoToToday={goToToday}
          openFilters={openFilters}
          onToggleFilters={() => setOpenFilters(!openFilters)}
          filtersButtonLabel={filtersButtonLabel}
          showClearFilters={showClearFilters}
          onClearFilters={clearAllFilters}
        />
        {openFilters && (
          <CalendarFilters
            type={type}
            onTypeChange={setType}
            onOpenExecutoresModal={() => setExecutoresSetoresModalOpen(true)}
            onOpenAmbientesModal={() => setAmbientesEquipamentosModalOpen(true)}
            onOpenPlanosModal={() => setPlanosModalOpen(true)}
            planosSelectionLabel={planosSelectionLabel}
          />
        )}
      </CalendarToolBar>

      <CalendarContentWrapper>
        {isLoadingEvents && (
          <CalendarLoadingOverlay>
            <LkpLoading />
          </CalendarLoadingOverlay>
        )}
        <DndContext onDragEnd={handleDragEndEvent} collisionDetection={closestCenter}>
          {view === CalendarView.Semana && (
            <WeekView
              weekDays={weekDays}
              events={calendarEvents}
              horasPrevistasByDate={horasPrevistasByDate}
              isCompletedView={type === 'baixadas'}
            />
          )}
        </DndContext>
      </CalendarContentWrapper>
    </CalendarContainer>
  );
};
